import React, { Component, useState } from "react";
import * as _ from "lodash";

import Daily from "./Daily";
import Practice from "./Practice";
import Learn from "./Learn";
import Settings from "./Settings";
import Welcome from "./Welcome";

import { getLocaleIsRtl } from "./util/localisation";
import {
  getVisits,
  incrementVisits,
  getIsDarkTheme,
  getIsUsa,
  getIsMobileAlertClosed,
  setIsMobileAlertClosed,
  addSettingsChangeListener,
  removeSettingsChangeListener,
} from "./util/settings";

import "./App.css";

const KEY_MAINNAV = "NAV_MAIN";

const NAV_SETTINGS = "settings";
const NAV_PRACTICE = "practice";
const NAV_PLAY = "play";
const NAV_LEARN = "learn";

export default class App extends Component {
  state = {
    mainNav: "quiz1",
    dailyStarted: false,
  };

  componentWillMount() {
    const mainNav = window.localStorage.getItem(KEY_MAINNAV);

    const visits = getVisits();

    this.setState({
      mainNav: mainNav || "learn",
      showWelcome: !(visits > 0),
    });

    if (visits > 0) {
      incrementVisits();
    }

    this.setLocalisation();
    this.setBodyClsFromTheme();
  }

  componentDidMount() {
    this.setNavWidth();
    window.addEventListener("resize", this.setNavWidth, false);

    addSettingsChangeListener("isDark", this.setBodyClsFromTheme);
    addSettingsChangeListener("dateFormat", this.setLocalisation);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setNavWidth, false);

    removeSettingsChangeListener("isDark", this.setBodyClsFromTheme);
    removeSettingsChangeListener("dateFormat", this.setLocalisation);
  }

  onWelcomeContinueClick = () => {
    this.closeWelcome();
  };

  onWelcomeSettingsClick = () => {
    this.closeWelcome();
    this.setNav(NAV_SETTINGS);
  };

  closeWelcome = () => {
    this.setState({
      showWelcome: false,
    });
    incrementVisits();
  };

  setLocalisation = () => {
    this.setState({
      isUsa: getIsUsa(),
      isRtl: getLocaleIsRtl(),
    });
  };

  setBodyClsFromTheme = () => {
    const { body } = window.document;
    if (getIsDarkTheme()) {
      body.classList.add("--dark");
    } else {
      body.classList.remove("--dark");
    }
  };

  componentDidUpdate() {
    this.setNavWidth();
  }

  setNavWidth = () => {
    if (this.navInnerEle) {
      this.navInnerEle.style.width = this.navEle
        ? this.navEle.offsetWidth + "px"
        : null;
    }
  };

  onDailyStart = () => {
    this.setState({
      dailyStarted: true,
    });
  };

  onDailyEnd = () => {
    this.setState({
      dailyStarted: false,
    });
  };

  onMainNavClickFn = _.memoize((mainNav) => (evt) => {
    evt.preventDefault();
    this.setNav(mainNav);
  });

  setNav = (mainNav) => {
    this.setState({
      mainNav,
    });
    window.localStorage.setItem(KEY_MAINNAV, mainNav);
  };

  navRef = (ele) => {
    this.navEle = ele;
  };

  navInnerRef = (ele) => {
    this.navInnerEle = ele;
  };

  render() {
    const { mainNav, showWelcome, dailyStarted, isUsa, isRtl } = this.state;

    return (
      <div className="App">
        <DesktopNote />

        <div
          className="-nav --main"
          ref={this.navRef}
          dir={isRtl ? "rtl" : null}
        >
          <nav ref={this.navInnerRef}>
            <button
              className={mainNav === "learn" ? "--on" : ""}
              onClick={this.onMainNavClickFn("learn")}
              disabled={dailyStarted}
            >
              <span>Learn</span>
            </button>
            <button
              className={mainNav === NAV_PRACTICE ? "--on" : ""}
              onClick={this.onMainNavClickFn(NAV_PRACTICE)}
              disabled={dailyStarted}
            >
              <span>{isUsa ? "Practice" : "Practise"}</span>
            </button>
            <button
              className={mainNav === NAV_PLAY ? "--on" : ""}
              onClick={this.onMainNavClickFn(NAV_PLAY)}
            >
              <span>Play</span>
            </button>
            <button
              className={
                "-settings" + (mainNav === NAV_SETTINGS ? " --on" : "")
              }
              onClick={this.onMainNavClickFn(NAV_SETTINGS)}
            >
              <span>⚙️</span>
            </button>
          </nav>
        </div>

        {showWelcome && (
          <Welcome
            onContinueClick={this.onWelcomeContinueClick}
            onSettingsClick={this.onWelcomeSettingsClick}
          />
        )}

        <div className="-view">
          {mainNav === NAV_PLAY && (
            <Daily onStart={this.onDailyStart} onEnd={this.onDailyEnd} />
          )}

          {mainNav === NAV_PRACTICE && <Practice />}

          {mainNav === NAV_LEARN && <Learn />}

          {mainNav === NAV_SETTINGS && <Settings />}
        </div>
      </div>
    );
  }
}

const DesktopNote = () => {
  const [isOpen, setOpen] = useState(!getIsMobileAlertClosed());
  const onButtonClick = (evt) => {
    evt.preventDefault();
    setOpen(false);
    setIsMobileAlertClosed();
  };
  if (!isOpen) {
    return null;
  }
  return (
    <div className="-desktopNote">
      <button type="button" onClick={onButtonClick}>
        &times;
      </button>
      Weekle is designed for mobile,
      <br />
      ...but you can use it here too.
      <br />
      <br />
      To play on mobile visit
      <br />
      <a href="https://benjoffe.com/weekle">benjoffe.com/weekle</a>
      <br />
      ...or scan below:
      <div className="-qr" />
    </div>
  );
};
